import React, { useEffect, useState } from "react";
import { CircularProgress, Dialog, DialogContent, DialogTitle, Fade } from "@mui/material";
import Box from '@mui/material/Box';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import EditIcon from '@mui/icons-material/Edit';
import MyLabel from "../../myLabel";
import MyButton from "../../myButton";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import { style } from "./styles";
import { getAyrsharePost } from "../../../services/ayrshare/getAyrsharePost";
import MyInputText from "../../myInputText";
import MyImage from "../../myImage"
import SocialIcon from '../socialIcons'
import alertSvg from "../../../assets/imgs/panels/alert.svg";
import toast from "react-hot-toast";
import CloseIcon from '@mui/icons-material/Close';

import MyDataTimeInput from "../../myDataTimeInput";
import DoneIcon from '@mui/icons-material/Done';
import useViewTemplateState from "../../../hooks/ayrshare/useViewTemplateState";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import formatLocaleDate from "../../../utils/formatLocaleDate";
import DragDropImage from "./dragDropImage";
import image01 from "../../../assets/imgs/image01.png";
import ButtonDropImage from "./buttonDropImage";

const EditButtons = ({handlerSave, handlerCancel}) => {

    return (
        <Box sx={{width:'16pt'}}>
            <DoneIcon onClick={handlerSave} sx={{ color: 'green', fontSize:'15pt', cursor:'pointer', marginRight:'10px'}} />
            <CloseIcon onClick={handlerCancel} sx={{color: 'red', fontSize:'15pt', cursor:'pointer'}} />
        </Box>
    )
}

function MessageDialogDelete({open, handleClose, handlerSuccess}) {
  
    return (
        <Dialog  open={open} onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
            <MyLabel component='p' text={" "}  />
        </DialogTitle>
        <DialogContent>
          <Box sx={{margin:'30px'}}>
            <Box sx={{display: 'flex', flexDirection:'row',justifyContent:'space-around', alignItems: 'center', width: '100%', margin:'10px'}}>
                <MyLabel component='p' text={"Do you really want to delete this post?"}  />
            </Box>
            <Box sx={{display: 'flex', flexDirection:'row',justifyContent:'space-around', alignItems: 'center', width: '100%', margin:'10px'}}>
                    <MyButton 
                        sx={style.cancelButton}
                        onClick={handleClose}
                        text='no'
                        variant="contained" 
                        size="small"
                    />
                    <MyButton 
                        sx={{...style.exitButton, marginBottom:0}}
                        onClick={handlerSuccess}
                        text='yes'
                        variant="contained" 
                        size="small"
                        color='warning'
                    />
                </Box>
          </Box>
        </DialogContent>
      </Dialog>
    )
}



const ViewFacebook = ({profileSelected, post, information, handleClose, updateListPost}) => {

    const AnalitcArea = () => {

        

        if (post.platform === 'facebook'){
            if(!information.facebook){
                return <></>
            }
            return (
                <>
                    <Box>
                            <Box sx={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                                <MyLabel component='p' text={information.facebook?.analytics?.likeCount ?? 0} sx={{fontSize:'11pt', marginRight:'5px'}} noTranslate={true} />

                                <MyLabel component='p' text='Likes' sx={{fontSize:'11pt'}} />
                            </Box>
                        </Box>
                        <Box sx={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'start'}}>
                            <Box sx={{marginRight:'20px'}}>
                                <Box sx={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                                    <MyLabel component='p' text={information.facebook.analytics?.commentsCount ?? 0} sx={{fontSize:'11pt', marginRight:'5px'}} noTranslate={true} />
                                    <MyLabel component='p' text='Comments' sx={{fontSize:'11pt'}} />
                                </Box>
                            </Box>
                            <Box>
                                <Box sx={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                                    <MyLabel component='p' text={information.facebook.analytics?.sharesCount ?? 0} sx={{fontSize:'11pt', marginRight:'5px'}} noTranslate={true} />
                                    <MyLabel component='p' text='Share' sx={{fontSize:'11pt'}} />
                                </Box>
                            </Box>
                        </Box>
                </>
    
            )
        }
        else if (post.platform === 'linkedin'){
            return (
                <>

                </>
    
            )
        }
        else if (post.platform === 'twitter'){
            if(!information.twitter){
                return <></>
            }
            return (
                <>
                    <Box>
                            <Box sx={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                                <MyLabel component='p' text={information?.twitter?.analytics?.publicMetrics?.likeCount} sx={{fontSize:'11pt', marginRight:'5px'}} noTranslate={true} />
                                <MyLabel component='p' text='Likes' sx={{fontSize:'11pt'}} />
                            </Box>
                        </Box>
                        <Box sx={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'start'}}>
                            <Box sx={{marginRight:'20px'}}>
                                <Box sx={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                                    <MyLabel component='p' text={information?.twitter?.analytics?.publicMetrics.replyCount} sx={{fontSize:'11pt', marginRight:'5px'}} noTranslate={true} />
                                    <MyLabel component='p' text='Reply' sx={{fontSize:'11pt'}} />
                                </Box>
                            </Box>
                            <Box>
                                <Box sx={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                                    <MyLabel component='p' text={information?.twitter.analytics?.publicMetrics.retweetCount} sx={{fontSize:'11pt', marginRight:'5px'}} noTranslate={true} />
                                    <MyLabel component='p' text='Retweet' sx={{fontSize:'11pt'}} />
                                </Box>
                            </Box>
                        </Box>
                </>
    
            )
        }
        else if (post.platform === 'instagram'){
            if(!information.instagram){
                return <></>
            }
            
            return (
                <>
                    <Box>
                            <Box sx={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                                <MyLabel component='p' text={information?.instagram?.analytics?.likeCount ?? 0} sx={{fontSize:'11pt', marginRight:'5px'}} noTranslate={true} />
                                <MyLabel component='p' text='Likes' sx={{fontSize:'11pt'}} />
                            </Box>
                        </Box>
                        <Box sx={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'start'}}>
                            <Box sx={{marginRight:'20px'}}>
                                <Box sx={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                                    <MyLabel component='p' text={information.instagram.analytics?.commentsCount ?? 0} sx={{fontSize:'11pt', marginRight:'5px'}} noTranslate={true} />
                                    <MyLabel component='p' text='Comments' sx={{fontSize:'11pt'}} />
                                </Box>
                            </Box>
                            <Box>
                                <Box sx={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                                    <MyLabel component='p' text={information.instagram.analytics?.sharesCount ?? 0} sx={{fontSize:'11pt', marginRight:'5px'}} noTranslate={true} />
                                    <MyLabel component='p' text='Share' sx={{fontSize:'11pt'}} />
                                </Box>
                            </Box>
                        </Box>
                </>
    
            )
        }
        
    }

    const states = useViewTemplateState(profileSelected, post, handleClose, updateListPost)
    const [dialogDelete, setDialogDelete] = useState(false);

    let name = post.platform;
    

    const handlerEdit = (type) => {
        if (type === 'date'){
            states.postDate.set(formatLocaleDate(post.post.post_date))
        }
        else if (type === 'text'){
            states.text.set(post.post.text)
        }
        else if (type === 'image'){
            states.image.set(post.post.image ? post.post.image : '-')
        }

        
    }

    const handlerGenerateIA = () =>{
        states.imageAuto.set()
    }

    const handlerAutoGenerateIA = () =>{
        states.imageAuto.set()
    }

    const ImageArea = () => {

        if (states.image.value){

            return (
                <Fade in={true} timeout={600}>
                    <Box sx={{marginTop:'15px', display:'flex', justifyContent:'center'}}>
                        {
                            states.image.value === '-' ?
                            <Box sx={style.addImageArea}>
                                    <Box sx={{display:'flex', justifyContent:'center'}} >
                                        <DragDropImage image={states.image} setFile={states.file.set} />
                                    </Box>
                                    <Box sx={{display:'flex', justifyContent:'center'}} >
                                        <Card onClick={handlerAutoGenerateIA} sx={{...style.cardAreaImage, ...style.areaClick, backgroundImage: `url(${image01})`,}}>
                                            <CardContent sx={style.cardAreaContent}>
                                                <Box sx={{...style.cardTitleArea,  backgroundColor:'#0082ff'}}>
                                                    <MyLabel component='p' text="AUTO-GENERATE WITH AI" sx={style.cardTitle}  />
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </Box>
                                </Box>
                                : 
                                <Box sx={{display: 'flex', justifyContent:'center', width: '100%',margin:'10px'}}>
                                    <Box sx={{display: 'flex', justifyContent:'center', flexDirection: 'column', alignItems:'center'}}>
                                    
                                    <MyImage src={states.image.value} alt={`Image`}  sx={{...style.cardAreaImage,backgroundImage:'none'}} />

                                    {
                                        states.file.value ? 
                                        <Box sx={{marginTop:'5px'}}>
                                            <ButtonDropImage image={states.image} setFile={states.file.set} />
                                        </Box>
                                        : null
                                    }
                                    <MyButton onClick={handlerGenerateIA} text={states.file.value ? "Generate with AI2":"Generate other image"} variant="text" /> 
                                </Box>
                            </Box>
                        }
                        <EditButtons handlerSave={states.update.set} handlerCancel={()=> states.image.set(null)}/>
                    </Box>
                </Fade>
            )
        }

        return (
            <Box sx={{marginTop: '10px', display:'flex', justifyContent:'center'}}>

                    {
                        post.post.image ? 
                        <Box sx={{}}>
                            <MyImage sx={{maxHeight:'30vh', borderRadius:'5px', width:'100%', objectFit: 'contain'}} src={`${post.post.image}`} alt={"image post"} /> 
                        </Box>
                        : 
                        <Box sx={{display: 'flex', justifyContent:'center'}}>
                            <Box sx={{margin:'10px 20px 10px 20px', height:'190px', width:'190px', backgroundColor:'#e7e7e7', borderRadius:'5px',display:'flex', justifyContent: 'center', alignItems:'center', alignContent:'center'}}>
                                <MyLabel component='p' text={'(NO IMAGE ADDED)'} sx={{color:'#9b9b9b', fontWeight:600,fontSize:'8pt'}} />
                            </Box>
                        </Box>
                    }
                    {
                        post.status !== 'scheduled' ? 
                            null
                        :
                            states.image.value ? 
                                null
                            : <Box sx={{width:'16pt'}}><EditIcon onClick={()=>handlerEdit('image')} sx={{color: '#376db4', fontSize:'15pt', cursor:'pointer'}} /></Box>
                    }
                </Box>
        )

    }
  
    return (
        <>
            <Box >
                <Box sx={{marginBottom:'5px', display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
                    <Box sx={{display:'flex', flexDirection:'row', alignContent:'center', alignItems:'center'}}>
                        <Box sx={{marginRight:'10px'}}>
                            <SocialIcon icon={post.platform} linked={true} onClick={()=>{window.open(post.url, '_blank');}}  sx={{height:'50px', width:'50px', cursor:'pointer'}} />
                        </Box>
                        <Box>
                            <Box>
                                <MyLabel component='p' text={name} sx={style.text} noTranslate={true} />
                            </Box>
                            <Box sx={{display:'flex', flexDirection:'row', height:'40px',alignItems:'center'}}>
                                <Box >
                                    {
                                        !states.postDate.value? 
                                            <MyLabel component='p' text={formatLocaleDate(post.post.post_date)} sx={{fontSize:'10pt'}} noTranslate={true} />
                                        :
                                        <MyDataTimeInput 
                                            value={states.postDate.value} 
                                            onChange={(newValue) => states.postDate.set(newValue)} 
                                            size='small'
                                            />
            
                                    }
                                </Box>
                                <Box sx={{marginLeft:'5px'}}>
                                    {
                                        post.url && post.url !== '-' ?
                                            <PublicOutlinedIcon onClick={()=>{window.open(post.url, '_blank');}}  sx={{color: '#376db4', fontSize:'15pt', cursor:'pointer'}} />
                                            : post.status !== 'scheduled' ?
                                            <MyImage onClick={()=> toast(post.message_error)} src={alertSvg} sx={{cursor:'pointer', height:'20px', width: '20px'}} />
                                            : states.postDate.value ? 
                                                <EditButtons handlerSave={states.update.set} handlerCancel={()=> states.postDate.set(null)}/>
                                            : <Box sx={{width:'16pt'}}><EditIcon onClick={()=>handlerEdit('date')} sx={{color: '#376db4', fontSize:'15pt', cursor:'pointer'}} /></Box>
                                            
                                            
                                    }
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    
                    {
                         post.status === 'scheduled' ?
                            <Box sx={{ display:'flex', flexDirection:'row',}}>
                                {
                                    states.submit.value ? <CircularProgress size='2em' /> : null
                                }
                                <Box>
                                    <DeleteOutlineIcon onClick={()=>setDialogDelete(true)} sx={{ color: 'red', cursor: 'pointer' }} />
                                </Box>
                            </Box>
                        : null
                    }
                </Box>
                <Box  sx={{display:'flex', flexDirection:'row'}}>
                    <MyInputText 
                        maxRows={15} 
                        disabled={states.text.value === null} 
                        value={states.text.value ? states.text.value : post.post.text}
                        onChange={(e) =>{
                                states.text.set(e.target.value)
                            }
                        }
                    />
                    {
                        post.status !== 'scheduled' ? 
                            null
                        :
                            states.text.value ? 
                                <EditButtons handlerSave={states.update.set} handlerCancel={()=> states.text.set(null)}/>
                            : <Box sx={{width:'16pt'}}><EditIcon onClick={()=>handlerEdit('text')} sx={{color: '#376db4', fontSize:'15pt', cursor:'pointer'}} /></Box>
                    }
                </Box>
                <ImageArea />
                
                <Box sx={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
                    {
                        post.status !== 'scheduled' && information ? <AnalitcArea /> : null
                    }
                </Box>

            </Box>
            <MessageDialogDelete open={dialogDelete} handleClose={()=>setDialogDelete(false)} handlerSuccess={()=>{states.delete.set(post.post.id);setDialogDelete(false)}} />
        </>
    )

}

function ViewDialog({profileSelected, post, open, handleClose, information, updateListPost}) {

    const defView = (handleClose) =>
    {

        if (post.platform === 'facebook'){
            return <ViewFacebook profileSelected={profileSelected} handleClose={handleClose} post={post} information={information} updateListPost={updateListPost} />
        }

        else{
            return <ViewFacebook profileSelected={profileSelected} handleClose={handleClose} post={post} information={information} updateListPost={updateListPost}/>
        }

    }
  
    return (
        <Dialog  open={open} onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent sx={style.content}>
            <Box>
                
                {
                    defView(handleClose)
                }
                
            </Box>
            <Box sx={{display: 'flex', flexDirection:'row',justifyContent:'space-around', alignItems: 'center', width: '100%', margin:'10px'}}>
                <MyButton 
                    sx={style.scheduleButton}
                    onClick={handleClose}
                    text='return'
                    variant="contained" 
                    size="small"
                />
            </Box>
        </DialogContent>
      </Dialog>
    )
}

const ViewTemplate = ({profileSelected, post, open, handleClose, updateListPost}) => {

    const [information, setInformation] = useState(null)

    const KEY = process.env.REACT_APP_AYRSHARE_KEY

    useEffect(() => {

        const get = async () =>{
            
            let result = await getAyrsharePost(
                post.post.profile_key,
                post.post.ayrshare_id,
                [post.platform],
                KEY
            )
            setInformation(result)
        }

        if (open){
            get()
        }

    }, [open]);

    return (
        <>
            <ViewDialog profileSelected={profileSelected} open={open} handleClose={handleClose} post={post} information={information} updateListPost={updateListPost} />
        </>
    )
}

export default ViewTemplate;